function PageDiv({children}) {
	return (
		<div className={"flex-fill p-3 m-3 bg-white shadow-sm border overflow-auto"}>
			{children}
		</div>
	);
}

export default PageDiv;
